import { OverlayProps } from './types';
import { StyledOverlay } from './style';

function Overlay({
    children,
    preview = false,
    showOverlay = true,
    visible = true,
    overlayPercentage = 50,
    zIndex = 10
}: OverlayProps) {
    return (
        <StyledOverlay
            preview={preview}
            showOverlay={showOverlay}
            visible={visible}
            overlayPercentage={overlayPercentage}
            zIndex={zIndex}
        >
            {children}
        </StyledOverlay>
    );
}

export default Overlay;
